import { OrderStatuses } from '@services';
import { FaStar } from 'react-icons/fa';
import { GrFormCheckmark } from 'react-icons/gr';
import { IoMdClose } from 'react-icons/io';
import { RiHourglassFill } from 'react-icons/ri';
import { BsCartPlusFill } from 'react-icons/bs';

export const StatusProvider = ({ status }: { status: OrderStatuses }) => {
    switch (status) {
        case OrderStatuses.CREATED:
            return (
                <div className="order-item-created">
                    <RiHourglassFill fontSize={28} color="#B3E0CA" />
                </div>
            );
        case OrderStatuses.CONFIRMED:
        case OrderStatuses.VALIDATED:
        case OrderStatuses.SYNCHRONIZED:
            return (
                <div className="order-item-confirmed">
                    <GrFormCheckmark fontSize={28} color="white" />
                </div>
            );
        case OrderStatuses.DELETED:
            return (
                <div className="order-item-deleted">
                    <IoMdClose fontSize={28} color="white" />
                </div>
            );
        case OrderStatuses.FAVORITED:
            return (
                <div className="order-item-favorited">
                    <FaStar fontSize={24} color="white" />
                </div>
            );
        case OrderStatuses.UPDATED:
            return (
                <div className="order-item-updated">
                    <BsCartPlusFill fontSize={24} color="white" />
                </div>
            );
        default:
            return <div className="order-item-status">Inconnue</div>;
    }
};
